import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _pt from 'prop-types';
import { cloneElement } from 'react';
import { warning, filterDataAttributes, filterAriaAttributes } from '@commercetools-uikit/utils';
import { I as InlineSvg } from '../../dist/inline-svg-a7ff5c85.esm.js';
import _fillInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/fill';
import { designTokens } from '@commercetools-uikit/design-system';
import { css } from '@emotion/react';
import { jsx } from '@emotion/react/jsx-runtime';
import 'dompurify';
import 'react-from-dom';

const sizeMap = {
  10: designTokens.spacing50,
  20: `calc(${designTokens.spacing50} + ${designTokens.spacing20})`,
  30: designTokens.spacing60,
  40: designTokens.spacing70
};
const colorThemeMap = {
  accent: {
    light: {
      fill: designTokens.colorAccent40,
      background: designTokens.colorAccent90
    },
    dark: {
      background: designTokens.colorAccent40,
      fill: designTokens.colorNeutral90
    }
  },
  brown: {
    light: {
      background: designTokens.colorBrown90,
      fill: designTokens.colorBrown50
    },
    dark: {
      background: designTokens.colorBrown50,
      fill: designTokens.colorNeutral90
    }
  },
  customSvg: {
    light: {
      background: designTokens.colorSurface,
      border: `solid ${designTokens.borderWidth1} ${designTokens.colorNeutral90}`,
      fill: 'inherit'
    },
    dark: {
      background: designTokens.colorSolid,
      fill: 'inherit'
    }
  },
  neutral: {
    light: {
      background: designTokens.colorNeutral90,
      fill: designTokens.colorNeutral40
    },
    dark: {
      background: designTokens.colorNeutral40,
      fill: designTokens.colorNeutral90
    }
  },
  purple: {
    light: {
      background: designTokens.colorPurple90,
      fill: designTokens.colorPurple50
    },
    dark: {
      background: designTokens.colorPurple50,
      fill: designTokens.colorNeutral90
    }
  },
  turquoise: {
    light: {
      background: designTokens.colorTurquoise90,
      fill: designTokens.colorTurquoise35
    },
    dark: {
      background: designTokens.colorTurquoise50,
      fill: designTokens.colorNeutral90
    }
  },
  white: {
    light: {
      background: designTokens.colorSurface,
      border: `solid ${designTokens.borderWidth1} ${designTokens.colorNeutral90}`,
      fill: designTokens.colorNeutral60
    },
    dark: {
      background: designTokens.colorSolid,
      fill: designTokens.colorNeutral90
    }
  }
};
function getPaddingStyles(_ref) {
  let size = _ref.size,
    hasBorder = _ref.hasBorder;
  switch (size) {
    case 'customSvg':
      return null;
    case '10':
      // https://github.com/commercetools/ui-kit/pull/2701#issuecomment-1914413390
      return `calc(${designTokens.spacing10} + ${hasBorder ? '0px' : '1px'})`;
    default:
      // https://github.com/commercetools/ui-kit/pull/2701#issuecomment-1914413390
      return `calc(${designTokens.spacing20} + ${hasBorder ? '0px' : '1px'})`;
  }
}
const getLeadingIconStyles = props => {
  const sizeStyles = {
    height: sizeMap[props.size],
    width: sizeMap[props.size]
  };
  const colorThemeStyles = colorThemeMap[props.svg ? 'customSvg' : props.color][props.isInverted ? 'dark' : 'light'];
  const paddingStyle = getPaddingStyles({
    size: props.svg ? 'customSvg' : props.size,
    hasBorder: Boolean(props.svg || props.color === 'white' && !props.isInverted)
  });
  return /*#__PURE__*/css("display:flex;flex:0 0 auto;justify-content:center;align-items:center;padding:", paddingStyle, ";height:", sizeStyles.height, ";width:", sizeStyles.width, ";border-radius:", designTokens.borderRadius4, ";color:", _fillInstanceProperty(colorThemeStyles), ";fill:", _fillInstanceProperty(colorThemeStyles), ";background-color:", colorThemeStyles.background, ";box-sizing:border-box;border:", colorThemeStyles.border, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:getLeadingIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const defaultProps = {
  color: 'neutral',
  size: '20',
  isInverted: false
};
const LeadingIcon = props => {
  if (!props.svg && !props.icon) {
    process.env.NODE_ENV !== "production" ? warning(false, 'LeadingIcon: you must pass either an icon or svg prop to the LeadingIcon component') : void 0;
    return null;
  }
  return jsx("div", _objectSpread(_objectSpread(_objectSpread({
    role: "img",
    css: getLeadingIconStyles(props)
  }, filterDataAttributes(props)), filterAriaAttributes(props)), {}, {
    children: props.svg ? jsx(InlineSvg, {
      data: props.svg,
      size: 'scale'
    }) : props.icon && /*#__PURE__*/cloneElement(props?.icon, {
      size: 'scale'
    })
  }));
};
LeadingIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _pt.oneOf(['white', 'neutral', 'purple', 'turquoise', 'accent', 'brown']),
  size: _pt.oneOf(['10', '20', '30', '40']),
  isInverted: _pt.bool,
  icon: _pt.element,
  svg: _pt.string
} : {};
LeadingIcon.displayName = 'LeadingIcon';
LeadingIcon.defaultProps = defaultProps;
var LeadingIcon$1 = LeadingIcon;

export { LeadingIcon$1 as default };
